// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.group-member-dots-menu {
    float: right;
    margin: 5px 10px;
}
.group-member-dots-menu .menu-item {
    padding: 5px 10px 5px 20px;
}
.floating-menu.group-member-dots-menu svg.dots {
    width: 24px;
    height: 24px;
    margin-top: -8px;
}
`, "",{"version":3,"sources":["webpack://./client/components/groups/members/GroupMembersList/GroupMemberBadge/GroupMemberDotsMenu/GroupMemberDotsMenu.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB","sourcesContent":[".group-member-dots-menu {\n    float: right;\n    margin: 5px 10px;\n}\n.group-member-dots-menu .menu-item {\n    padding: 5px 10px 5px 20px;\n}\n.floating-menu.group-member-dots-menu svg.dots {\n    width: 24px;\n    height: 24px;\n    margin-top: -8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
